import React from "react";
import { useLocation } from "react-router-dom";
import "./Footer.css";

function Footer() {
  const location = useLocation();

  const isAdvancedPage = location.pathname === "/advanced-editor";

  return (
    <footer className={`site-footer ${isAdvancedPage ? "dark-footer" : "light-footer"}`}>
      <div className="footer-container">
        <div className="footer-brand">
          <h2>SmartPDF</h2>
          <h3>AI-Powered Document Intelligence System.</h3>
          <p>
            A smart PDF productivity platform for conversion, OCR, editing,
            summarization, question generation, and study notes.
          </p>
        </div>

        <div className="footer-grid">
          <div className="footer-section">
            <h3>Quick Links</h3>
            <a href="/">Home</a>
            <a href="/advanced-editor">Advanced Tools</a>
            <a href="/editor">PDF Editor</a>
          </div>

          <div className="footer-section">
            <h3>Contact</h3>
            <a href="mailto:sajidhussai09n@gmail.com">
              sajidhussai09n@gmail.com
            </a>

            <a
              href="https://smartpdf-qsw.pages.dev/"
              target="_blank"
              rel="noreferrer"
            >
              SmartPDF Website
            </a>
          </div>

          <div className="footer-section">
            <h3>About</h3>

            <button className="footer-about-btn"
            onClick={() => window.open('https://mshussain.netlify.app/', '_blank')}
            >
              About Me
            </button>

            <p>
              Built by Sajid Hussain for fast and intelligent PDF workflows.
            </p>
          </div>
        </div>

        <div className="footer-bottom">
          © 2026 SmartPDF. All rights reserved.
        </div>
      </div>
    </footer>
  );
}

export default Footer;